import type { AlignmentMetrics } from '../../hooks/useSessionResultsAnalytics';
import { C } from '../../theme/participantTokens';

interface AlignmentSummaryProps {
  alignment: AlignmentMetrics;
}

function AlignmentRow({ label, pct }: { label: string; pct: number }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
      <span style={{ fontFamily: 'degular-variable, -apple-system, BlinkMacSystemFont, system-ui, sans-serif', fontSize: '0.95rem', color: C.textTer, width: 90, flexShrink: 0 }}>
        {label}
      </span>
      <div style={{ flex: 1, height: 2, background: C.ruleBright }}>
        <div
          className="pp-draw-bar"
          style={{ height: '100%', width: `${pct}%`, background: C.slate, opacity: 0.9 }}
        />
      </div>
      <span style={{ fontFamily: 'JetBrains Mono', fontSize: '0.85rem', fontWeight: 700, color: C.textSec, width: 40, textAlign: 'right' }}>
        {pct}%
      </span>
    </div>
  );
}

export function AlignmentSummary({ alignment }: AlignmentSummaryProps) {
  if (alignment.overallPct === 0 && alignment.submittedCount === 0) return null;

  return (
    <div
      className="pp-results-enter"
      style={{
        background: C.surface,
        border: `1px solid ${C.rule}`,
        borderLeft: `2px solid ${C.slate}`,
        borderRadius: 4,
        padding: '16px 18px',
        marginBottom: 12,
      }}
    >
      <div style={{ fontFamily: 'JetBrains Mono', fontSize: '0.78rem', fontWeight: 600, letterSpacing: '0.15em', color: C.textTer, textTransform: 'uppercase', marginBottom: 6 }}>
        Your Alignment with Group Consensus
      </div>
      <div style={{ fontFamily: 'degular-variable, -apple-system, BlinkMacSystemFont, system-ui, sans-serif', fontSize: '1rem', fontWeight: 300, color: C.textSec, lineHeight: 1.5, marginBottom: 14 }}>
        Your rankings agreed with the group on {alignment.overallPct}% of items
        {alignment.sessionAveragePct > 0 ? ` — session average is ${alignment.sessionAveragePct}%.` : '.'}
        {alignment.top5Pct === 100 ? ' Top-5 picks matched consensus exactly.' : ''}
      </div>
      <AlignmentRow label="Overall" pct={alignment.overallPct} />
      <AlignmentRow label="Top 5 items" pct={alignment.top5Pct} />
      <AlignmentRow label="Bottom 5" pct={alignment.bottom5Pct} />
    </div>
  );
}
